<template>
  <div class="add-field" @click="addField()">
    <i class="fal fa-plus-square fa-fw text-lg"></i>
    <span>{{ addText }}</span>
  </div>
</template>

<script>
export default {
  name: "BdgAddField",
  props: {
    addText: { type: String, required: true },
    newValue: { default: "" },
    value: { type: Array }
  },
  watch: {
    fieldsVal(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    addField() {
      this.fieldsVal.push(this.newValue);
    }
  },
  data() {
    return {
      fieldsVal: this.value
    };
  }
};
</script>

<style lang="scss" scoped>
:not(.flex-row):not(.flex) {
  & > .bdg-input {
    & + .add-field {
      @apply mt-4;
    }
  }
}
</style>
